import React, { useState, componentDidMount } from 'react';
import { MDBInput, MDBContainer } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCSRFInfo } from '../../system/redux/reducers/csrfReducer';
import ClipLoader from "react-spinners/ClipLoader";
import { setUserInfo } from '../../system/redux/reducers/roleReducer';
import { apiHostUrl, applicationContextRoot, getSurveybyDepartmentSRVCUser, getSurveybyEncryptedData, getSurveybyId, loginUrl, primary_theme_color } from '../../../constants/constants';
import { getLoginInfoUrl } from '../../../constants/constants';
import { setMenuInfo } from '../../system/redux/reducers/menuReducer';
import { useForm } from "react-hook-form";
import API_Routes from '../../../constants/api-routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { activeProfile } from '../../../constants/constants';
import { headers } from '../../../constants/constants';
import { useRefreshState } from '../../hooks/useRefreshState';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Stack from '@mui/material/Stack';
import { setSurveyInfo } from '../../system/redux/reducers/surveyReducer';
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import { setNavigationData } from '../../system/redux/reducers/NavigatedDataReducer';

const LoginForm = ({ onErrorFromLogin, param, encoded }) => {

  const { isAuthenticated } = useRefreshState();
  const {  fetchUserState } = useRefreshState();
  const isCaptchaEnabled = useSelector((state) => state.userState.isCaptchaEnabled);
  const isCaptchaForSurveyEnabled = useSelector((state) => state.userState.isCaptchaForSurveyEnabled);
  // useEffect(() => {
  //   fetchUserState(); // fetch on mount
  // }, [fetchUserState]);

  const { i18n, t } = useTranslation();
  const [ctoken, setCtoken] = useState('');
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [response1URL, setResponse1URL] = useState('');
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [menu, setMenu] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const { homeLink } = useSelector(state => state.role);
  const [password, setPassword] = useState('');
  const [captchaCode, setCaptchaCode] = useState('');
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const { userEmail, role } = useSelector((state) => state.role);
  const { menuItems } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#44006b");
  let disable = false;
  if (loading) {
    disable = true;
  }
  // const [headers, setHeaders] = useState({
  //   'X-Csrf-Token': csrfToken,
  //   'Content-Type': 'application/json'
  // });
  const headers1 = {
    'Accept': '*/*',
    'X-Csrf-Token': csrfToken,
    // 'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Credentials': true,
    'redirect': 'false'
  };
  const { handleSubmit, formState } = useForm();
  const { isSubmitting } = formState;
  const [paramId, setParamId] = useState('');
  const encodedUrl = apiHostUrl + getSurveybyEncryptedData;
  const getSurveybyDepartmentSRVCUserUrl = apiHostUrl + getSurveybyDepartmentSRVCUser;
  const surveyURLbyId = apiHostUrl + getSurveybyId;
  const formData = new FormData();
  const [encode, encoding] = useState(encoded);
  const { param1 } = useParams();
  const { departmentId } = useParams();
  const { srvcUserId } = useParams();
  const [responseSuveyQuestion, setResponseSuveyQuestion] = useState();
  const [responseSuveyQuestionParam, setResponseSuveyQuestionParam] = useState();
  const [isparam, setIsparam] = useState(false);
  const [checkData, setcheckData] = useState(false);
  
  useEffect(() => {
    if (encoded) {
      console.log("Param is a string:", param1);
      axios.get(encodedUrl + "/" + param1, { withCredentials: true }, headers1,
      ).then((response) => {
        const responsead = response;
        console.log(response);
        setResponseSuveyQuestion(response);
        setcheckData(true);
      });
    }

  }, [param1]);

   useEffect(() => {
       console.log('Is Captcha Enabled:', isCaptchaEnabled);       
     }, [isCaptchaEnabled]);

   useEffect(() => {
       console.log('Is Captcha Enabled:', isCaptchaForSurveyEnabled);       
     }, [isCaptchaForSurveyEnabled]);

  useEffect(() => {
    if (!encoded && departmentId && departmentId > 0) {
      console.log("Param departmentId:", departmentId);
      console.log("Param srvcUserId:", srvcUserId);
      axios.get(getSurveybyDepartmentSRVCUserUrl + "/" + departmentId + "/" + srvcUserId, { withCredentials: true }, headers1,
      ).then((response) => {
        // debugger;
        const responsead = response;
        console.log(response);
        setResponseSuveyQuestion(response);
        setcheckData(true);
      });
    }

  }, [srvcUserId]);
  // useEffect(() => {
  //   console.log("Param is a string you know?", param1);
  //   axios.get(surveyURLbyId + "/" + param1, { withCredentials: true }, headers1,
  //   ).then((response) => {
  //     const responsead = response;
  //     console.log(response);
  //     setResponseSuveyQuestionParam(response);
  //     setcheckData(false);
  //   });
  // }, [param1]);

  useEffect(() => {
    if (checkData) {
      handleNavigate();
    }
  }, [responseSuveyQuestion])


  useEffect(() => {
    if (responseSuveyQuestionParam?.status == 200) {

      setIsparam(true);
    }
  }, [responseSuveyQuestionParam])

  useEffect(() => {

    if (isparam && param1 != null && responseSuveyQuestionParam) {

      handleNavigateParam();
    }
  }, [responseSuveyQuestionParam])



  const onTrigger = (msg) => {
    onErrorFromLogin(msg);
    console.log('input' + msg);
  };

  const handleNavigation = (err) => {
    debugger;
  
    if (err.includes("login") || err.includes("multi") || err.includes("session") || err.includes("reset") || err.includes("password") || err.includes("get-mfa")) {
    }
    else if (param && encoded) {
      navigate(applicationContextRoot + '/survey')
    }
    else if (param) {
      // const serializedData = JSON.stringify(responseSuveyQuestionParam);
      // navigate(applicationContextRoot + '/survey/launch-survey/', { state: { responseSuveyQuestionParam: serializedData } })
      handleNavigateParam();
    }
    else {
      navigate(applicationContextRoot + '/home');
    }
  }

  const handleNavigate = () => {
    console.log('Survey')
    console.log(responseSuveyQuestion);
    //debugger;
    dispatch(setSurveyInfo(responseSuveyQuestion));
    const serializedData = JSON.stringify(responseSuveyQuestion);
    const id = serializedData?.data?.surveyList[0]?.id;
    // navigate(`/cchp-ui/survey/launch-survey/${id}`, { state: { responseSuveyQuestion: serializedData } });
    //navigate(applicationContextRoot + '/survey/launch-survey/', { state: { responseSuveyQuestion: serializedData } });
    navigate(applicationContextRoot + '/survey/launch-survey/');

  }
  // const handleNavigateParam = () => {
  //   console.log('Survey')
  //   console.log(responseSuveyQuestionParam);
  //   const serializedData = JSON.stringify(responseSuveyQuestionParam);
  //   const id = serializedData?.data?.surveyList[0]?.id;
  //   // navigate(`/cchp-ui/survey/launch-survey/${id}`, { state: { responseSuveyQuestion: serializedData } });
  //   navigate(applicationContextRoot + '/survey/launch-survey/', { state: { responseSuveyQuestionParam: serializedData } });

  // }

  const handleNavigateParam = () => {
    debugger;
    if (typeof param === "string") {
      axios.get(surveyURLbyId + "/" + param, { withCredentials: true }, headers1,
      ).then((response) => {
        // debugger
        setResponseSuveyQuestionParam(response)
        const responsead = response;
        console.log(response);
      });
    }

  };
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  }

  useEffect(() => {
    console.log('Survey with parameter');
    console.log(responseSuveyQuestionParam);
    if (responseSuveyQuestionParam?.data?.surveyList?.length > 0) {
      dispatch(setSurveyInfo(responseSuveyQuestionParam));
      const serializedData = JSON.stringify(responseSuveyQuestionParam);
      const id = serializedData?.data?.surveyList[0]?.id;
      // navigate(applicationContextRoot + '/survey/launch-survey/', { state: { responseSuveyQuestionParam: serializedData } });
      navigate(applicationContextRoot + '/survey/launch-survey/');
    } else {
      console.error('No survey data found in responseSuveyQuestionParam');
      // Handle the case when there is no survey data
    }
  }, [responseSuveyQuestionParam])

  function onSubmit() {
    debugger;
    setLoading(true);
    let formData = "userName=" + email + "&password=" + encodeURIComponent(password)+ "&param=" + param + "&_csrf=" + csrfToken;
    if (param !== undefined && encoded === undefined
      ? isCaptchaForSurveyEnabled
      : isCaptchaEnabled) formData += "&captchaCode=" + captchaCode;
    axios.post(loginUrl, formData, { withCredentials: true }, headers,
    ).then((response) => {
   
      dispatch(setNavigationData({}));
      const responsead = response.request.responseURL;
      console.log(responsead);
      setParamId(param);

      let decodedErrorMessage = decodeURIComponent(responsead.split('=').pop().replace(/\+/g, ' '));
      if (decodedErrorMessage.includes("http") && !decodedErrorMessage.includes("mfa") && !decodedErrorMessage.includes("reset") && (!param || (param && responsead.includes("multi-sign-decision")))) {
        decodedErrorMessage = t('general.error.msg.unknown');
        setError(t('general.error.msg.unknown'));
      }

      if (responsead.includes("session-invalid")) {
        decodedErrorMessage = t('general.error.msg.unknown');
        setError(t('general.error.msg.unknown'));
      }
      else if (responsead.includes("mfa")) {
        decodedErrorMessage = 'Otp sent Successfully';
        setError(t('general.label.send.otp.success'));
      }
      else {
        if(!param || (param && responsead.includes("multi-sign-decision"))){
          setError(decodedErrorMessage);
          console.log(decodedErrorMessage);
        }
        if((param && responsead.includes("credentials"))){
          setError(decodedErrorMessage);
          console.log("111"+decodedErrorMessage);
          onTrigger(decodedErrorMessage);
        }
      }
      if(!param || (param && responsead.includes("multi-sign-decision"))){
        onTrigger(decodedErrorMessage);
      }

      console.log("Decoded Error Message: ", decodedErrorMessage);
      setLoading(false);
      handleNavigation(responsead)
      refreshCaptchaHandler();
    })
      .catch((error) => {
        console.log(error);
        refreshCaptchaHandler();
      });

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 2000);
    });
  }

  const getCaptchaWTimeUrl = () => {
    return API_Routes.getCaptchaWOTimeUrl + Date.now();
  }
  const [captchaImg, setCaptchaImg] = useState(getCaptchaWTimeUrl());
  const refreshCaptchaHandler = () => {
    setCaptchaImg(getCaptchaWTimeUrl());
  }
  useEffect(() => {
    console.log("Inside login form");
    if (isAuthenticated) {
      if(homeLink.startsWith("redirect:/survey/")){
        handleNavigateParam();
      }else{
        navigate(applicationContextRoot + "/home");
      }
    }
  }, [isAuthenticated]);
  debugger;
  console.log(isCaptchaForSurveyEnabled);
  console.log(isCaptchaEnabled);
  return (
    <>
      {!encode && (<form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
          <InputLabel className='fw-medium form-label text-black' htmlFor="outlined-adornment-email">{t('general.placeHolder.email')}</InputLabel>
          <TextField
            id="outlined-adornment-email"
            fullWidth
            size="small"
            type='email'
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined" />

          {/* <OutlinedInput
            fullWidth
            id="outlined-adornment-email"
            type='email'
            onChange={(e) => setEmail(e.target.value)}
            label={t('general.placeHolder.email')}
          /> */}

        </div>
        {/* Email input */}
        {/* <MDBInput wrapperClass='mb-4'
      label={t('general.placeHolder.email')}
      id='form1'
      type='email'
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    /> */}

        <div className="mb-3">

          <InputLabel className='fw-medium form-label text-black' htmlFor="outlined-adornment-password">{t('general.placeHolder.password')}</InputLabel>
          <TextField
            id="outlined-adornment-password"
            fullWidth
            size="small"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        {(param !== undefined && encoded === undefined
      ? isCaptchaForSurveyEnabled
      : isCaptchaEnabled) &&
          <div>
            <Form.Group className="mb-3 mt-4" controlId="exampleForm.ControlInput1">
              <Form.Label className='fw-medium'>{t("general.label.captcha")}</Form.Label>

              <InputGroup>
                <InputGroup.Text className='float-start position-static order-0 p-0'>
                  <Stack gap={0} direction='row' className='img-thumbnail'>
                    <img src={captchaImg} alt="Captcha Code" className='captcha-img border rounded' />
                    <Button variant="link" size='lg' onClick={refreshCaptchaHandler}>
                      <FontAwesomeIcon icon={faArrowsRotate} > </FontAwesomeIcon>
                    </Button>
                  </Stack>

                </InputGroup.Text>
                <Form.Control id='form3'
                  type='text'
                  value={captchaCode}
                  onChange={(e) => setCaptchaCode(e.target.value)}
                  placeholder={t('general.placeHolder.captcha')} />
              </InputGroup>
            </Form.Group>
            {/* <MDBInput wrapperClass='mb-1 mt-4'
            label={t('general.placeHolder.captcha')} id='form3'
            type='text'
            value={captchaCode}
            onChange={(e) => setCaptchaCode(e.target.value)}

          /> */}
          </div>
        }


        <input type="hidden" name="_csrf" />

        {/* Submit button */}

        <div>

          <Button type='submit' className='w-100' size='lg'>{t('general.label.signin')}
            {isSubmitting && <span className="spinner-border spinner-border-sm ml-2"></span>}</Button>{' '}
        </div>
      </form>)}
    </>
  )
}


export default LoginForm;